var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"progress"},[_c('li',{staticClass:"progress__active"},[_vm._v(_vm._s(_vm.title.active))]),_vm._v(" "),_c('li',{staticClass:"progress__dormant"},[_c('span'),_vm._v(_vm._s(_vm.title.dormant))])])}
var staticRenderFns = []

export { render, staticRenderFns }